export const WIDTH = 1000
export const HEIGHT = 120
export const NORMALIZE = 0.8
